<template>
  <div>
    <baseFrame
      :infosArr="infosArr"
      :id="stocktakingPlan.serialNumber"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="盘点结果信息">
          <lk-card title="复盘-差异商品" v-if="secondDiffData.length">
            <lk-table border :columns="secondDiffColumns" :data="secondDiffData" height="300"></lk-table>
          </lk-card>
          <lk-card title="初盘-差异商品" v-if="firstDiffData.length">
            <lk-table border :columns="firstDiffColumns" :data="firstDiffData" height="300"></lk-table>
          </lk-card>
          <lk-card title="复盘-无差异商品" v-if="secondNoDiffData.length">
            <lk-table border :columns="secondNoDiffColumns" :data="secondNoDiffData" height="300"></lk-table>
          </lk-card>
          <lk-card title="初盘-无差异商品" v-if="firstNoDiffData.length">
            <lk-table border :columns="firstNoDiffColumns" :data="firstNoDiffData" height="300"></lk-table>
          </lk-card>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import sharedData from '../../libs/sharedDara';

export default {
  components: {
    baseFrame,
  },
  data() {
    return {
      infosArr: [],
      stocktakingPlan: {},
      adjustTotalCount: 0,
      adjustTotalPrice: 0,
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      boolsMap: new Map([
        [1, '是'],
        [2, '否'],
      ]),
      firstNoDiffData: [],
      firstNoDiffColumns: [ // 一次盘点无差异商品
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '盘点人员', key: 'operatorName', minWidth: 110 },
        { title: '初盘数量', key: 'realCount', minWidth: 110 },
      ],
      firstDiffData: [],
      firstDiffColumns: [ // 一次盘点有差异商品
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '盘点人员', key: 'operatorName', minWidth: 110 },
        { title: '初盘数量', key: 'realCount', minWidth: 110 },
        { title: '复盘数量', key: 'secondRealCount', minWidth: 110 },
        { title: '损溢数量', key: 'adjustCount', minWidth: 110 },
        { title: '损溢金额', key: 'amout', minWidth: 110 },
      ],
      secondNoDiffData: [],
      secondNoDiffColumns: [ // 二次盘点无差异商品
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '盘点人员', key: 'operatorName', minWidth: 110 },
        { title: '初盘数量', key: 'realCount', minWidth: 110 },
        { title: '复盘数量', key: 'secondRealCount', minWidth: 110 },
      ],
      secondDiffData: [],
      secondDiffColumns: [ // 二次盘点-有差异商品
        {
          type: 'expand',
          width: 60,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subSecondDiffColumns,
              data: params.row.stocktakingAdjustList,
              width: '1000'
            },
          })
        },
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '商品状态', key: 'goodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '盘点人员', key: 'operatorName', minWidth: 110 },
        { title: '初盘数量', key: 'realCount', minWidth: 110 },
        { title: '复盘数量', key: 'secondRealCount', minWidth: 110 },
        { title: '损溢数量', key: 'adjustCount', minWidth: 110, fixed: 'right' },
        { title: '损溢金额', key: 'amout', minWidth: 110, fixed: 'right' },
        { title: '未处理损溢数量', key: 'noDealNum', minWidth: 110, fixed: 'right' },
        { title: '已处理损溢数量', key: 'processedNum', minWidth: 110, fixed: 'right' },
        { title: '已处理损溢金额', key: 'proceedAmount', minWidth: 110, fixed: 'right' },
      ],
      subSecondDiffTempData: [], // 点击时的那一条对应的损溢单
      subSecondDiffData: [], // 存放所有的损溢单
      subSecondDiffColumns: [
        { title: '损溢单号', key: 'code', minWidth: 110 },
        { title: '审批状态', key: 'statusStr', minWidth: 110 },
        { title: '商品编码', key: 'serialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '批次', key: 'adjustBatchSeq', minWidth: 110 },
        { title: '本次处理损溢数量', key: 'num', minWidth: 110 },
        { title: '本次处理损溢金额', key: 'amount', minWidth: 110 },
        { title: '损溢原因', key: 'reason', minWidth: 110 },
        { title: '是否调整库存', key: 'changeInventory', minWidth: 110 },
        { title: '创建人员', key: 'createUserName', minWidth: 110 },
        { title: '创建时间', key: 'createTime', minWidth: 110 },
      ],
    };
  },
  computed: {},
  methods: {
    dealGoodsStatus(array) { //处理转换商品转态字段为文字
      if (array instanceof Array) {
        array.forEach(item => {
          if (item.goodsStoreStatus) {
            item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
          }
        })
        return array
      }
    },
    deleteSpecialColumn(columns, list) {
      for(let i = 0; i < columns.length; i++) {
        if (list.includes(columns[i].key)) {
          columns.splice(i, 1);
          i--;
        }
      }
      return columns
    },
    getData() {
      const params = {
        stocktakingPlanId: Number.parseInt(this.$route.params.id, 10),
        menuSourceType: 1,
        status: this.$route.params.status
      }
      inventory.stocktakingRecordList(params)
        .then((res) => {
          if (res.data.status === 200) {
            const { stocktakingPlan, stocktakingRecords, stocktakingRecordFn, stocktakingRecordFy, stocktakingRecordSy, stocktakingRecordSn, stocktakingAdjustVoList } = res.data.data;
            if (stocktakingPlan && stocktakingPlan.operatorPattern && stocktakingPlan.operatorPattern === 2) {
              const list = ['breakageFrozenAmount', 'inventoryCount', 'manualFrozenNum', 'inInventoryCount'];
              this.firstNoDiffColumns = this.deleteSpecialColumn(this.firstNoDiffColumns, list);
              this.firstDiffColumns = this.deleteSpecialColumn(this.firstDiffColumns, list);
              this.secondNoDiffColumns = this.deleteSpecialColumn(this.secondNoDiffColumns, list);
              this.secondDiffColumns = this.deleteSpecialColumn(this.secondDiffColumns, list);
              // 暗盘计算损溢金额
              stocktakingRecordFy.forEach(item => {
                item.amout = '';
              });
              stocktakingRecordSy.forEach(item => {
                item.amout = '';
              })
            }
            // 明盘计算损溢金额
            if (stocktakingPlan && stocktakingPlan.operatorPattern && stocktakingPlan.operatorPattern === 1) {
              stocktakingRecordFy.forEach(item => {
                item.amout = item.adjustCount * item.priceBeforeTax;
              });
              stocktakingRecordSy.forEach(item => {
                item.amout = item.adjustCount * item.priceBeforeTax;
                item.proceedAmount = item.processedNum * item.priceBeforeTax;
              });
            }
            if (stocktakingRecordSy instanceof Array) {
              stocktakingRecordSy.forEach(item => {
                if (item.stocktakingAdjustList instanceof Array) {
                  item.stocktakingAdjustList.forEach(item => {
                    item.createTime = utils.formatTime(item.createTime);
                    if (item.num && item.priceBeforeTax) {
                      item.amount = item.num * item.priceBeforeTax // 前端自己计算损溢金额
                    }
                    if (item.changeInventory) {
                      item.changeInventory = item.changeInventory === 1 ? '是' : '否';
                    }
                  })
                }
              })
            }
            this.firstNoDiffData = this.dealGoodsStatus(stocktakingRecordFn);
            this.firstDiffData = this.dealGoodsStatus(stocktakingRecordFy);
            this.secondNoDiffData = this.dealGoodsStatus(stocktakingRecordSn);
            this.secondDiffData = this.dealGoodsStatus(stocktakingRecordSy);
            this.adjustTotalCount = utils.addPlusPrefix(this.adjustTotalCount.toFixed(2));
            this.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(this.adjustTotalPrice));
            this.setInfoArr(stocktakingPlan);
            this.stocktakingPlan = stocktakingPlan;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
    },
    setInfoArr(stocktakingPlan) {
      if (!stocktakingPlan) {
        return;
      }
      stocktakingPlan.hasZeroStr = this.boolsMap.get(stocktakingPlan.hasZero);
      stocktakingPlan.createTime = utils.formatDate(stocktakingPlan.createTime);
      stocktakingPlan.operatorType = sharedData.operatorTypeList[stocktakingPlan.operatorType - 1].name;
      stocktakingPlan.operatorPattern = sharedData.operatorPatternsList[stocktakingPlan.operatorPattern - 1].name;
      stocktakingPlan.operatorTime = utils.exchangeTimeToSecond(stocktakingPlan.operatorTime);
      if (stocktakingPlan.secondOperatorTime) {
        stocktakingPlan.checkTime = `${utils.exchangeTimeToSecond(stocktakingPlan.firstOperatorTime)}-${utils.exchangeTimeToSecond(stocktakingPlan.secondOperatorTime)}`;
      } else {
        stocktakingPlan.checkTime = utils.exchangeTimeToSecond(stocktakingPlan.firstOperatorTime);
      }
      stocktakingPlan.checkNames = `${stocktakingPlan.firstOperatorName} ${stocktakingPlan.secondOperatorName || ''}`
      if (!stocktakingPlan.warehouseNames) {
        stocktakingPlan.warehouseNames = '全部';
      }

      const infosArr = [
        {
          name: '盘点计划名称:',
          value: stocktakingPlan.name,
        },
        {
          name: '盘点类型:',
          value: stocktakingPlan.operatorType,
        },
        {
          name: '盘点方式:',
          value: stocktakingPlan.operatorPattern,
        },
        {
          name: '是否含0在库数量商品:',
          value: stocktakingPlan.hasZeroStr,
        },
        {
          name: '盘点仓库:',
          value: stocktakingPlan.warehouseNames,
        },
        {
          name: '创建人员:',
          value: stocktakingPlan.createUserName,
        },
        {
          name: '创建时间:',
          value: stocktakingPlan.createTime,
        },
        {
          name: '盘点人员:',
          value: stocktakingPlan.allOperatorName,
        },
        {
          name: '盘点时间:',
          value: stocktakingPlan.operatorTime,
        },
        {
          name: '录入人员:',
          value: stocktakingPlan.checkNames,
        },
        {
          name: '录入时间:',
          value: stocktakingPlan.checkTime,
        },
      ];
      this.infosArr = infosArr;
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
